/* eslint-disable object-curly-newline */
import {
  storeActionCommit,
} from '@/utils/common-utils';

export default {
  setAuthorizationInfos({ commit }, { authorization }) {
    return storeActionCommit(commit, 'setAuthorizationInfos')(authorization);
  },
};
